<template>
  <TextOverTooltip :content="names">
    <div>
      等
      <el-tooltip placement="top" :content="names">
        <span class="box-right-special">{{ len }}个</span>
      </el-tooltip>
    </div>
  </TextOverTooltip>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
  roleList: {
    type: Array,
    default: () => [],
  },
})

const len = computed(() => props.roleList.length)
const names = computed(() =>
  props.roleList?.map((item) => item.name).join('、'))


</script>
<style lang="scss" scoped>
::v-deep(.cell) {
  > span {
    display: block;
    width: 100%;
  }
}
.box-right-special {
    cursor: pointer;
    color: #366cfe;
}
</style>
